import React, {useMemo} from 'react';
import useSWR from "swr";
import {swrFetcher} from "../utils/api.ts";
import {Account} from "../types.ts";
import Select from "./form/Select.tsx";


function AccountChooser({value, onChange, platform}:{
    value: Account,
    platform: Account['platform'];
    onChange:(val: Account)=>void
}) {
    const {data, isLoading} = useSWR<{accounts:Account[]}>(`/accounts?status=active`,swrFetcher)
    const filtered = useMemo(()=>{
        if(!data) return [];
        return data.accounts.filter((i)=>i.platform === platform)
    },[platform, data])
    if(isLoading){
        return <select
            style={{maxWidth:200, width:200}}
            className={"placeholder form-control placeholder-wave"}></select>
    }
    return (
            <Select
                style={{maxWidth:200}}
                hasEmpty
                options={filtered.map((i)=>{
                return {
                    label: i.username || i.name,
                    value: i.id,
                }
            })} value={value || ''} onChange={onChange} />
    );
}

// function AccountChooser({value, onChange, platform}:{
//     value: Account[],
//     platform: Account['platform'];
//     onChange:(val: Account[])=>void
// }) {
//     const {data, isLoading} = useSWR<{accounts:Account[]}>('/accounts',swrFetcher)
//     const filtered = useMemo(()=>{
//         if(!data) return [];
//         return data.accounts.filter((i)=>i.platform === platform)
//     },[platform, data])
//     const [visible, toggle] = useToggle(false);
//     return (
//         <React.Fragment>
//             <Modal
//                 onOk={toggle}
//                 okText={"Done"}
//                 title={"Choose an account"} visible={visible} onClose={toggle}>
//                 <ul className="list-group">
//                 {
//                     filtered.map((i)=>{
//                         return <button
//                             onClick={()=>{
//                                 if(value.find(({id})=>id == i.id)){
//                                     onChange(value.filter(({id})=>id != i.id))
//                                 }else {
//                                     onChange([...(value || []), i])
//                                 }
//                             }}
//                             key={String(i.id)} className={"list-group-item-action align-items-center d-flex gap-2 py-3 list-group-item"}>
//                             <RenderPlatformIcon platform={i.platform} />
//                             {i.username || i.name}
//                             {
//                                 value.find(({id})=>id == i.id) ? <span className="badge bg-primary">selected</span> : null
//                             }
//                         </button>
//                     })
//                 }
//                 </ul>
//             </Modal>
//             <Button className={"btn btn-secondary"} onClick={toggle}>
//                 {
//                     value?.length === 1 ? <span>{value[0].username}</span> : null
//                 }
//                 {
//                     value?.length > 1 ? <span>{value[0].username} + {value.length - 1} more</span> : null
//                 }
//                 {
//                     !value || value?.length === 0 ? <span>Choose an account</span> : null
//                 }
//             </Button>
//         </React.Fragment>
//     );
// }

export default AccountChooser;
